import { teamsListPageSize } from '@gonfalon/dogfood-flags/dogfood-flags';
import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';
import { isEmpty } from 'lodash';
import qs from 'qs';

/**
 * Teams Filter
 */
export type TeamsFiltersProps = {
  query: string;
  limit: number;
  offset: number;
  noAccess: boolean;
  accessCheck: string;
  accessCheckResource: string;
};

export class TeamsFilters extends Record<TeamsFiltersProps>({
  query: '',
  limit: -1,
  offset: 0,
  noAccess: true,
  accessCheck: '',
  accessCheckResource: '',
}) {
  toFrontendTeamsQueryString(options?: { omitPaginationParams?: boolean }) {
    const { query, limit, offset } = this;

    if (options?.omitPaginationParams) {
      return { ...(query && { query }) };
    }

    const validLimit = limit && limit > 0 && (offset || limit !== teamsListPageSize());

    return {
      ...(query && { query }),
      ...(validLimit && { limit }),
      ...(offset && { offset }),
    };
  }
  toQueryString(options?: { omitPaginationParams?: boolean }) {
    return qs.stringify(this.toFrontendTeamsQueryString(options), { indices: false });
  }
  toBackendQueryString() {
    const { query, limit, offset, noAccess, accessCheck, accessCheckResource } = this;
    const filter = new Array<string>();

    if (!noAccess) {
      filter.push(`noaccess:${noAccess}`);
    }

    if (accessCheck && accessCheckResource) {
      filter.push(`accessCheck:${accessCheck}`, `accessCheckResource:${accessCheckResource}`);
    }

    const q = {
      ...(query && { query }),
      ...(limit && limit > 0 && { limit }),
      ...(offset && { offset }),
      ...(filter.length > 0 && { filter: filter.join(',') }),
    };
    return qs.stringify(q, { indices: false, addQueryPrefix: true });
  }
  isEmpty() {
    return isEmpty(this.query);
  }
}

export function createTeamsFilters(props: Partial<TeamsFiltersProps>) {
  return props instanceof TeamsFilters ? props : new TeamsFilters(fromJS(props));
}
